const React = require('react');
const isNode = (typeof process !== 'undefined');
const Swiper = isNode ? require('swiper') : function() {};
const _ = require('./../../../lib/underscore');

class Swipe extends React.Component {
    constructor(props) {
        super(props);
        this.onResize = this.onResize.bind(this);
        this.className = _.uniqueId('swiper-')
    }

    componentDidMount() {
        const defaultOptions = {
            loop: true,
            paginationClickable: true,
            paginationHide: false
        };

        const options = _.extend(defaultOptions, this.props.options);

        this.swiper = new Swiper(`.${this.className}`, options);
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize() {
        setTimeout(() => this.swiper.update(true), 0);
    }

    render() {
        if (!isNode) return null;
        const {style, className, pagination } = this.props;

        const classes = [].concat('swiper-container', this.className, 'swiper', className).join(' ');
        return (
             <div className={classes} style={style}>
                 <div className="swiper-wrapper">
                     {this.props.children.map((child, index) => <div key={index} className="swiper-slide">{child}</div>)}
                 </div>
                 {pagination && (
                 <div className="swiper-pagination">
                     {this.props.children.map(_ => <span className="swiper-pagination-bullet"></span>)}
                 </div>
                 )}
             </div>
        );
    }
}

module.exports = Swipe;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Swipe/index.jsx